import Nav from "react-bootstrap/Nav";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const location = useLocation();

  const navStyle = (path) => ({
    color: "white",
    fontSize: "1.1rem",
    margin: "0 10px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: location.pathname === path ? "#023e73" : "transparent",
    textDecoration: "none",
  });

  return (
    <Nav
      className="justify-content-center p-3"
      style={{ backgroundColor: "#04549B" }}
    >
      <Nav.Item>
        <Link style={navStyle("/home")} to="/home">
          Home
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link style={navStyle("/create")} to="/create">
          Create Account
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link style={navStyle("/deposit")} to="/deposit">
          Deposit
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link style={navStyle("/withdraw")} to="/withdraw">
          Withdraw
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link style={navStyle("/alldata")} to="/alldata">
          All Data
        </Link>
      </Nav.Item>
    </Nav>
  );
}
